export default (pattern, width, height) =>
  pattern &&
  pattern.replace('{width}', width || '').replace('{height}', height || '');
